import React from 'react';
import HotelPresentationMain from './HotelPresentationMain';
import HotelPresentationSideBar from './HotelPresentationSideBar';
import '../../stylesheets/hotel-presentation.scss';

const HotelPresentation = () => {
    return (
        <>
            <div className='hotel-presentation__container'>
                <HotelPresentationMain />
                <HotelPresentationSideBar />
            </div>
        </>
    );
};

export default HotelPresentation;
